import React, { useState } from 'react';
import logo from '../../images/Improving_the_Future_Logo_no.png';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="navbar">
        <div className="navbar-left">
            <img src={logo} alt="Logo" className="logo" />
            <h1>Improving The Future</h1>
        </div>
        <div className="navbar-right">
            <div className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <ul className={menuOpen ? 'show' : ''}>
                <li><a href="/">Home</a></li>
                <li><a href="/education">Education</a></li>
                <li><a href="/farming">Farming</a></li>
                <li><a href="/services">Our Services</a></li>
                <li><a href="/about">About Us</a></li>
                <li><a href="/contact">Contact Us</a></li>
            </ul>
        </div>
    </nav>
  );
};

export default Navbar;